module.exports = __webpack_public_path__ + "static/media/image4.cd8fad7f.jpg";